let simName = location.host.split('.')[0];
let devGetWayProp = 'online'; // 用来切换环境 比如pre 写pre
let devSimName = 'sim271';
const GetWay = {
  dev: {
    env: 'dev',
    cApiBase: `http://${devSimName}.rlab.sim.intra.xiaojukeji.com/c-api`,
    cashierApiBase: `https://d${devSimName}-api.intra.xiaojukeji.com`,
    payApiBase: `https://d${devSimName}-api.intra.xiaojukeji.com`,
  },
  test: {
    env: 'test',
    cApiBase: 'https://c.didi-food.com',
    cashierApiBase: 'https://cashier.didiglobal.com',
    payApiBase: 'https://pay.didiglobal.com',
  },
  pre: {
    env: 'pre',
    cApiBase: 'https://pre-c.didi-food.com',
    cashierApiBase: 'https://cashier-pre.didiglobal.com',
    payApiBase: 'https://pay-pre.didiglobal.com',
  },
  online: {
    env: 'online',
    cApiBase: 'https://c.didi-food.com',
    cashierApiBase: 'https://cashier.didiglobal.com',
    payApiBase: 'https://pay.didiglobal.com',
  },
  sim: {
    env: 'sim',
    cApiBase: `http://${simName}.rlab.sim.intra.xiaojukeji.com/c-api`,
    cashierApiBase: `https://d${simName}-api.intra.xiaojukeji.com`,
    payApiBase: `https://d${simName}-api.intra.xiaojukeji.com`,
  },
};
GetWay['dev'] = GetWay[devGetWayProp || 'dev'];
export default GetWay;
